/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";
import TextField from "src/components/TextField";
import LoadableContent from "src/components/LoadableContent";

function RenameDeviceDialog(props) {
  const { onDismiss, onRename, isOpen, originalDeviceName } = props;
  const [error, setError] = useState(false);
  const [deviceName, setDeviceName] = useState(props?.deviceName || "");
  const [isProcessing, setIsProcessing] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!deviceName && isOpen) {
      setDeviceName(props?.deviceName || "");
    }
  }, [props?.deviceName, isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setError(false);
      setIsProcessing(false);
      setDeviceName("");
    }
  }, [isOpen]);

  async function handleDeviceRename() {
    if (!deviceName || deviceName?.length === 0) return;
    try {
      setIsProcessing(true);
      await onRename(deviceName);
      onDismiss();
    } catch (error) {
      setIsProcessing(false);
      setError(true);
    }
  }
  return (
    <Dialog
      isOpen={isOpen}
      isProcessing={isProcessing}
      heading={t("deviceList.renameDevice.heading")}
      text={t("deviceList.renameDevice.text", {
        value0: originalDeviceName || props?.deviceName
      })}
      buttons={[
        { text: t("buttons.cancel"), onClick: onDismiss },
        {
          text: t("buttons.save"),
          onClick: handleDeviceRename
        }
      ]}
      additionalContent={
        <>
          <TextField
            autoFocus
            width="296px"
            value={deviceName}
            placeholder={t("placeholders.deviceName")}
            onChange={({ target }) => setDeviceName(target.value)}
            type="text"
          />
          <LoadableContent showContent={error} showSpinner={false}>
            <Text mt="4px" color="red" fontSize="11px">
              {t("messages.actionFailed")}
            </Text>
          </LoadableContent>
        </>
      }
    />
  );
}

export default RenameDeviceDialog;
